import store from 'source/store';

function checkIfUserIsOwner(to, from, next) {
    const { is_organizational_exec } = store.state.auth.user.user_profile;
    const employmentId = store.state.auth.user.user_profile.employment_id;
    const isNotOwner = employmentId != to.params.employment_id;

    if (is_organizational_exec || isNotOwner)
        next({ name: 'access-denied', replace: true });
    else next();
}

export default [{
    path: 'career/:employment_id',
    name: 'employment',
    component: () => import('source/pages/root/EmploymentPageGroup.vue'),
    beforeEnter: checkIfUserIsOwner,
    meta: {
        title: 'Career - HQZen',
        canDisplayGlobalModals: true,
    },
    children: [
        {
            path: 'about',
            name: 'employment-information',
            component: () => import('source/pages/employment/EmploymentInformationPage.vue'),
            props: true,
            meta: {
                title: 'About career - HQZen',
                canDisplayGlobalModals: true,
            },
        },
        {
            path: '201-files',
            name: 'employment-201-files',
            component: () => import('source/pages/employment/Employment201FilesPage.vue'),
            props: true,
            meta: {
                title: '201 Files - HQZen',
                canDisplayGlobalModals: true,
            },
        },
        {
            path: 'timelog',
            name: 'employment-timelog',
            component: () => import('source/pages/employment/EmploymentTimelogPage.vue'),
            props: true,
            meta: {
                title: 'Timelogs - HQZen',
                canDisplayGlobalModals: true,
            },
            children: [
                {
                    path: ':current_employee_payroll_id/logs',
                    name: 'timelog-logs',
                    component: () => import('source/pages/supervisor-manager/employees/EmployeesPage.vue'),
                    meta: {
                        title: 'Timelogs - HQZen',
                        canDisplayGlobalModals: true,
                        isEmploymentPage: true,
                    },
                },
                {
                    path: ':current_employee_payroll_id/payslip',
                    name: 'timelog-payslip',
                    component: () => import('source/pages/employment/timelogs/TimelogPayslipSubpage.vue'),
                    meta: {
                        title: 'Payslip - HQZen',
                        canDisplayGlobalModals: true,
                    },
                },
                {
                    path: ':current_employee_payroll_id/activity',
                    name: 'timelog-activity',
                    component: () => import('source/pages/employment/timelogs/TimelogActivitySubpage.vue'),
                    meta: {
                        title: 'Activity - HQZen',
                        canDisplayGlobalModals: true,
                    },
                },
                {
                    path: ':current_employee_payroll_id/screenshots',
                    name: 'timelog-screenshots',
                    component: () => import('source/pages/employment/timelogs/TimelogScreenshotsSubpage.vue'),
                    meta: {
                        title: 'Screenshots - HQZen',
                        canDisplayGlobalModals: true,
                    },
                },
                {
                    path: ':current_employee_payroll_id/allowance-request/:issue_id',
                    name: 'allowance-request',
                    component: () => import('source/pages/employment/timelogs/TimelogAllowanceSubpage.vue'),
                    meta: {
                        title: 'Allowance - HQZen',
                        canDisplayGlobalModals: true,
                    }
                },
                {
                    path: ':current_employee_payroll_id/screenshots',
                    name: 'timelog-screenshots',
                    component: () => import('source/pages/employment/timelogs/TimelogScreenshotsSubpage.vue'),
                    meta: {
                        title: 'Screenshots - HQZen',
                        canDisplayGlobalModals: true,
                    },
                },
                {
                    path: ':current_employee_payroll_id/timelog-issue/:issue_id',
                    name: 'timelog-issue',
                    component: () => import('source/pages/employment/timelogs/TimelogIssueSubpage.vue'),
                    meta: {
                        title: 'Timelog Issue - HQZen',
                        canDisplayGlobalModals: true,
                    },
                },
                {
                    path: ':current_employee_payroll_id/schedule-issue/:issue_id',
                    name: 'schedule-issue',
                    component: () => import('source/pages/employment/timelogs/TimelogScheduleIssueSubpage.vue'),
                    meta: {
                        title: 'Schedule Issue - HQZen',
                        canDisplayGlobalModals: true,
                    },
                },
                {
                    path: ':current_employee_payroll_id/generic-issue/:issue_id',
                    name: 'generic-issue',
                    component: () => import('source/pages/employment/timelogs/TimelogGenericIssueSubpage.vue'),
                    meta: {
                        title: 'Generic Issue - HQZen',
                        canDisplayGlobalModals: true,
                    },
                },
            ]
        },
        {
            path: 'leaves',
            name: 'employment-leaves',
            component: () => import('source/pages/employment/EmploymentLeavesPage.vue'),
            props: true,
            meta: {
                title: 'Leaves - HQZen',
                canDisplayGlobalModals: true,
            },
            children: [
                {
                    path: 'details/:leave_id',
                    name: 'employment-leave-details',
                    component: () => import('source/pages/employment/leaves/LeaveDetailsPage.vue'),
                    props: true,
                    meta: {
                        title: 'Leave Details - HQZen',
                        canDisplayGlobalModals: true,
                    },
                }
            ]
        },
        {
            path: 'overtime',
            name: 'employment-overtime',
            component: () => import('source/pages/employment/EmploymentOvertimePage.vue'),
            props: true,
            meta: {
                title: 'Overtime - HQZen',
                canDisplayGlobalModals: true,
            },
        },
        {
            path: 'personnel-change-notices',
            name: 'employment-pcn',
            component: () => import('source/pages/employment/EmploymentPCNPage.vue'),
            props: true,
            meta: {
                title: 'Personnel Change Notices - HQZen',
                canDisplayGlobalModals: true,
            },
        },
        {
            path: 'incident-reports',
            name: 'employment-ir',
            component: () => import('source/pages/employment/EmploymentIRPage.vue'),
            props: true,
            meta: {
                title: 'Incident Reports - HQZen',
                canDisplayGlobalModals: true,
            },
            children: [
                {
                    path: 'details/:ir_id',
                    name: 'employment-ir-details',
                    component: () => import('source/pages/employment/incident-reports/IncidentReportDetailsPage.vue'),
                    props: true,
                    meta: {
                        title: 'Incident Report Details - HQZen',
                        canDisplayGlobalModals: true,
                    },
                }
            ]
        },
        {
            path: 'memorandums',
            name: 'employment-documents',
            component: () => import('source/pages/employment/EmploymentDocumentsPage.vue'),
            props: true,
            meta: {
                title: 'Memorandums - HQZen',
                canDisplayGlobalModals: true,
            },
            children: [
                {
                    path: 'details/:document_id',
                    name: 'employment-document-details',
                    component: () => import('source/pages/employment/documents/DocumentDetailsPage.vue'),
                    props: true,
                    meta: {
                        title: 'Memorandums - HQZen',
                        canDisplayGlobalModals: true,
                    },
                }
            ]
        },
        {
            path: 'disciplinary-actions',
            name: 'employment-daf',
            component: () => import('source/pages/employment/EmploymentDAFPage.vue'),
            props: true,
            meta: {
                title: 'Disciplinary Actions - HQZen',
                canDisplayGlobalModals: true,
            },
            children: [
                {
                    path: 'details/:daf_id',
                    name: 'employment-daf-details',
                    component: () => import(
                        'source/pages/employment/disciplinary-action-form/DAFDetailsPage.vue'),
                    meta: {
                        title: 'Disciplinary Actions - HQZen',
                        canDisplayGlobalModals: true,
                    }
                }
            ]
        },
        {
            path: 'accountabilities',
            name: 'employment-accountabilities',
            component: () => import('source/pages/employment/EmploymentAccountabilitiesPage.vue'),
            props: true,
            meta: {
                title: 'Accountabilities - HQZen',
                canDisplayGlobalModals: true,
            },
            children: [
                {
                    path: 'details/:accountability_id',
                    name: 'employment-accountability-details',
                    component: () => import(
                        'source/pages/employment/accountabilities/EmploymentAccountabilityDetailsPage.vue'),
                    meta: {
                        title: 'Accountabilities - HQZen',
                        canDisplayGlobalModals: true,
                        isInternal: true
                    }
                }
            ]
        },
        {
            path: 'leave-history',
            name: 'employment-leave-history',
            component: () => import('source/pages/employment/EmploymentLeaveHistoryPage.vue'),
            props: true,
            meta: {
                title: 'Leave History - HQZen',
                canDisplayGlobalModals: true,
            },
        },
    ]
},
];
